import { ClaimActionTypes, ClaimState } from "./types";

const initialState: ClaimState = {};

export const claimReducer = (
  state: ClaimState = initialState,
  action: ClaimActionTypes
): ClaimState => {
  switch (action.type) {
    default:
      return state;
  }
};
